import { ConcreteEncodable } from "./ConcreteEncodable";

import { SavedOrderEventImplEncoder } from "../../encoder/SavedOrderEventImplEncoder";

import * as CubiqTS from "../../index";
import { SavedOrderEvent } from "../SavedOrderEvent";

export class SavedOrderEventImpl extends ConcreteEncodable implements SavedOrderEvent {
  public static enType: string = "com.bcdfx.model.event.lifecycle.SavedOrderEventImpl";

  /*FID=1*/
  public componentState: Array<CubiqTS.StrategyComponentState> | null = null;
  /*FID=2*/
  public userCode: string;
  /*FID=3*/
  public submissionErrors: CubiqTS.Errors | null = null;
  /*FID=4*/
  public orderDataRequest: CubiqTS.LinkedOrderRequest | null = null;
  /*FID=5*/
  public fixingOrderRequest: CubiqTS.FixingOrderRequest | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = SavedOrderEventImplEncoder.Instance;
    this.setEncodableType(SavedOrderEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "SavedOrderEventImpl[" +
      "componentState=" +
      this.componentState +
      "userCode=" +
      this.userCode +
      "submissionErrors=" +
      this.submissionErrors +
      "orderDataRequest=" +
      this.orderDataRequest +
      "fixingOrderRequest=" +
      this.fixingOrderRequest +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
